import { render } from "./NewsItem.vue?vue&type=template&id=055a898d&scoped=true&ts=true"
import script from "./NewsItem.vue?vue&type=script&lang=ts"
export * from "./NewsItem.vue?vue&type=script&lang=ts"

import "./NewsItem.vue?vue&type=style&index=0&id=055a898d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055a898d"]])

export default __exports__